import React, { useState, useEffect, useCallback } from "react";
import "../page/doctorSpecialist.css";

import DoctorSpecialistTable from "../components/doctorSpecialistTable";
import DoctorSpecialistHeader from "../components/doctorSpecialistHeader";
import ModalDoctorSpecialist from "../components/modalDoctorSpecialist";
import ModalDeleteConfirmation from "../../../components/modal/modalDeleteConfirmation";
import { Constant } from "../../../helper/constant";
import { useNavigate } from "react-router-dom";

const DoctorSpecialist = () => {
  // =====================
  // Constant Definition
  // =====================
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isOpenModalAddSpecialist, setIsOpenModalAddSpecialist] =
    useState(false);
  const [page, setPage] = useState(0);

  const [selectedSpecialistData, setSelectedScpecialistData] = useState({
    doctor_specialist_id: "",
    doctor_specialist_name: "",
  });
  const [listSpecialistData, setListSpecialistData] = useState(null);
  const [isOpenModalDeleteSpecialist, setIsOpenModalDeleteSpecialist] =
    useState(false);
  const [idSpecialistToDelete, setIdSpecialistToDelete] = useState("");

  // =====================
  // Function Definition
  // =====================

  const addNewSpecialist = () => {
    resetSelectedSpecialistDataValue();
    setIsOpenModalAddSpecialist(true);
  };

  const onEditSpecialist = (specialistData) => {
    setSelectedScpecialistData(specialistData);
    setIsOpenModalAddSpecialist(true);
  };

  const onDeletepecialist = (specialistData) => {
    setIsOpenModalDeleteSpecialist(true);
    setIdSpecialistToDelete(specialistData.doctor_specialist_id);
  };

  const onDeleteSpecialistConfirmed = () => {
    setIsOpenModalDeleteSpecialist(false);
    deleteSpecialist();
  };

  const onCloseModalDeleteSpecialist = () => {
    setIdSpecialistToDelete("");
    setIsOpenModalDeleteSpecialist(false);
  };

  const onCloseModal = () => {
    resetSelectedSpecialistDataValue();
    setIsOpenModalAddSpecialist(false);
  };

  const onSubmitNewSpecialist = (specialistData, isEditData) => {
    setIsOpenModalAddSpecialist(false);
    if (isEditData) {
      editSpecialist(specialistData);
    } else {
      createNewSpecialist(specialistData);
    }
  };

  const resetSelectedSpecialistDataValue = () => {
    setSelectedScpecialistData({
      doctor_specialist_id: "",
      doctor_specialist_name: "",
    });
  };

  // =====================
  // Request Method
  // =====================

  const getSpecialistData = useCallback(async () => {
    try {
      setIsLoading(true);
      localStorage.setItem("searchValue", "");
      const response = await fetch(Constant.BASE_API_URL + "/spesialis", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
      });

      if (!response.ok) {
        alert("Gagal Menerima Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      const doctorSpeciality = data.doctor_speciality;

      if (!doctorSpeciality) {
        setListSpecialistData([]);
      }
      setListSpecialistData(doctorSpeciality);
    } catch (error) {
      setListSpecialistData([]);
    } finally {
      setIsLoading(false);
    }
  }, [navigate]);

  const createNewSpecialist = async (specialistData) => {
    try {
      setIsLoading(true);
      const response = await fetch(Constant.BASE_API_URL + "/spesialis", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify({
          doctor_specialist_name: specialistData.doctor_specialist_name,
        }),
      });
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
    } finally {
      getSpecialistData();
    }
  };

  const editSpecialist = async (specialistData) => {
    try {
      setIsLoading(true);
      const specialistId = specialistData.doctor_specialist_id;
      const response = await fetch(
        Constant.BASE_API_URL + "/spesialis/" + specialistId,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
          body: JSON.stringify({
            doctor_specialist_name: specialistData.doctor_specialist_name,
          }),
        }
      );
      if (!response.ok) {
        alert("Gagal Mengubah Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
    } finally {
      getSpecialistData();
    }
  };

  const deleteSpecialist = async () => {
    try {
      setIsLoading(true);
      const specialistId = idSpecialistToDelete;
      const response = await fetch(
        Constant.BASE_API_URL + "/spesialis/" + specialistId,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Gagal Menghapus Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }
    } finally {
      setIdSpecialistToDelete("");
      getSpecialistData();
    }
  };

  const searchSpecialist = (searchText) => {
    if (searchText.length > 3) {
      getSpecialistSearchData(searchText, false, false, "", "");
    } else if (searchText.length === 0) {
      getSpecialistData();
    }
  };

  const getSpecialistSearchData = useCallback(
    async (keyword, isNextPage, isPreviousPage, nextCursor, prevCursor) => {
      try {
        setIsLoading(true);

        let state = "";
        let cursorId = "";

        if (isNextPage) {
          state = "next_page";
          cursorId = nextCursor;
        } else if (isPreviousPage) {
          state = "previous_page";
          cursorId = prevCursor;
        }

        let url = new URL(Constant.BASE_API_URL + "/spesialis/search");
        url.searchParams.append("keyword", keyword);
        if (state !== "") {
          url.searchParams.append("cursor", cursorId);
          url.searchParams.append("state", state);
        } else {
          setPage(0);
        }

        const response = await fetch(Constant.BASE_API_URL + "/spesialis", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        });

        if (!response.ok) {
          alert("Gagal Menerima Data");
          if (response.status === 401 || response.status === 403) {
            localStorage.clear();
            return navigate("/login", { replace: true });
          }
        }
        const json = await response.json();
        const data = json.data;
        const doctorSpeciality = data.doctor_speciality;
        if (!doctorSpeciality) {
          setListSpecialistData(null);
        } else {
          setListSpecialistData(doctorSpeciality);
        }
      } catch (error) {
        setListSpecialistData(null);
      } finally {
        setIsLoading(false);
      }
    },
    [navigate]
  );

  // =====================
  // Use Effect Method
  // =====================

  useEffect(() => {
    getSpecialistData();
  }, [getSpecialistData]);

  // =====================
  // Render Method
  // =====================

  return isLoading ? (
    <div className="loading-container">
      <div className="loader"></div>
      <p>Sedang Memuat Mohon Menunggu</p>
    </div>
  ) : (
    <div>
      <h1>Poli Dokter</h1>
      <DoctorSpecialistHeader
        onAddSpecialistClicked={addNewSpecialist}
        onSearchSpecialistEdited={searchSpecialist}
      />
      <DoctorSpecialistTable
        specialists={listSpecialistData}
        onEditSpecialistClicked={onEditSpecialist}
        onDeleteSpecialistClicked={onDeletepecialist}
      />
      <ModalDoctorSpecialist
        isShowModal={isOpenModalAddSpecialist}
        onCloseModal={onCloseModal}
        onSubmitData={onSubmitNewSpecialist}
        specialistObject={selectedSpecialistData}
        key={Date.now()}
      />
      <ModalDeleteConfirmation
        isShowModal={isOpenModalDeleteSpecialist}
        onCloseModal={onCloseModalDeleteSpecialist}
        onDeleteConfirmed={onDeleteSpecialistConfirmed}
        idToDelete={idSpecialistToDelete}
      />
    </div>
  );
};

export default DoctorSpecialist;
